import { medicineRoutes, medicineUnits, Task } from "@/src/data/allTypes";
import { formatDate } from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { Tooltip } from "react-tooltip";

export function TreatmentEvent({
  task,
  onClick,
}: {
  task: Task;
  onClick?: () => void;
}) {
  const [isLoading, setIsLoading] = useState(false);
  let medicine = task.medicine;
  let shortUnitName = medicineUnits[task.unit]?.shortName;
  let routeName = medicineRoutes[task.route]?.shortName;
  if (!medicine) return <></>;
  let isNear =
    moment(task.start).isBefore(moment().add(1, "hour")) &&
    task?.status != "finished";
  let isPast =
    moment(task.start).isBefore(moment()) && task?.status != "finished";

  if (
    task.status == "finished" &&
    moment(task.finishedDate)?.diff(task.start, "minutes") > 120
  )
    isPast = true;


    function getPosology() {
    if(task?.posology?.toString()?.endsWith(".0")) return task?.posology?.toString()?.replace(".0", "");
    return task?.posology?.toString();
    }

  return (
    <div
      className={`treatmentEvent ${task?.status || ""}  tcenter ${
        isLoading ? "loading" : ""
      } ${isPast ? "past" : ""} ${isNear ? "near" : ""}`}
      style={{ borderRadius: "5px" }}
      onClick={async () => {
        setIsLoading(true);
        await onClick?.();
        setIsLoading(false);
      }}
      data-tooltip-id={`tooltipTreatmentEvent${task.id}`}
      data-tooltip-variant="info"
    >
      <div>{getPosology()}</div>
      <div>{shortUnitName || task?.unit || medicine?.defaultUnit}</div>
      <div className="gray normal mtop5">
        {["orale", "geste", "cutanée"]?.includes(task.route || "none")
          ? null
          : routeName}
      </div>
      <div className="mtop5" style={{ fontWeight: "normal" }}>
        {task?.status == "finished"
          ? formatDate(task?.finishedDate, "HH:mm")
          : ""}
      </div>

      {task?.notes != null &&
        task?.notes != "" &&
        task?.notes?.length > 100 && <div className="bold black">Notes*</div>}
      {task?.notes != null &&
        task?.notes != "" &&
        task?.notes?.length < 100 && (
          <div className="bold black">{task?.notes}</div>
        )}

      {(task?.dilutionVolume != null ||
        task?.duration != null ||
        task?.notes != null) && (
        <Tooltip
          id={`tooltipTreatmentEvent${task.id}`}
          place="right"
          variant="info"
          content={`${
            task?.dilutionVolume != 0 && task?.dilutionVolume != null
              ? `Dans ${task?.dilutionVolume} ml ${task?.dilutionSolution}`
              : ""
          }\n ${
            task?.duration != 0 && task?.duration != null
              ? `pendant ${task?.duration} minutes`
              : ""
          }\n ${task?.notes || ""}

        
                    `.trim()}
          // ${
          //   task?.finishedDate
          //     ? `Fait à ${moment(task?.finishedDate).format("HH:mm")} par ${
          //         task.doctor?.lastName
          //       }`
          //     : ""
          // }
          positionStrategy="fixed"
          style={{
            zIndex: 9999999999,
            maxWidth: "300px",
            background: "RGBA(255, 255, 255,1)",
            color: "black",
            fontWeight: "normal",
            fontSize: "14px",
            boxShadow: "2px 2px 10px RGBA(0,0,0,0.2)",
            padding: "15px",
            borderRadius: "10px",
          }}
        />
      )}
    </div>
  );
}
